// extracted by mini-css-extract-plugin
export default {"table":"articleList2_table__YISLw"};